import { useMemo } from 'react';
import { OnboardingStepKeyEnum } from '../../../components/Onboarding';
import AboutSmapModel from './AboutSmapModel';
import { Guider, GuiderStepConfig } from '../../../shared/molecules/Guider/Guider';

export function OnboardingSmap() {
  // Define steps
  const steps: GuiderStepConfig[] = [
      {
        key: "about_smap",
        divId: '[data-onboarding-id="strategy-map-header"]',
        renderModal: ({ isOpen, onClose }) => (
          <AboutSmapModel isOpen={isOpen} onClose={onClose} />
        ),
        placement: "bottom" as const,
      },
      {
        key: "about_page",
        divId: '[data-onboarding-id="strategy-map-header"]',
        message: "All Strategy Maps appear here",
        placement: "bottom",
      },
      // {
      //   key: "create_smap",
      //   divId: '[data-onboarding-id="create-smap-btn"]',
      //   message:
      //     "Start by creating a new Strategy Map to organize your Epics and Features",
      //   placement: "bottom",
      // },
      // {
      //   key: "filters",
      //   divId: '[data-onboarding-id="smap-filters"]',
      //   message: "Use filters to find Strategy Maps by Epic or Feature used",
      //   placement: "bottom",
      // },

      // {
      //   key: 'risk_awareness',
      //   getDiv: getAtRiskCard,
      //   condition: () => hasAtRiskRoadmaps,
      //   message: (ctx) => `${ctx.entityName ? `"${ctx.entityName}"` : 'This item'} is At Risk. Let's investigate why.`,
      //   onNext: async (ctx) => {
      //     if (ctx.entityId && JWTdata?.org_role === 'admin') {
      //        window.dispatchEvent(new CustomEvent('cadence:risk-open', { detail: { id: ctx.entityId } }));
      //     }
      //   }
      // },
      // {
      //   key: 'risk_analyze',
      //   waitFor: async () => waitForAnalyzeButtonVisible(context.entityId),
      //   condition: () => hasAtRiskRoadmaps && !!context.entityId,
      //   message: "Click 'Analyse Deeper' to open detailed risk analysis.",
      //   onNext: async (ctx) => {
      //     // Open Chat with prefill
      //     const prompt = `Analyse why @${ctx.entityName} is at risk? Provide actionable recommendations to mitigate the risk.`;

      //     setChatPrefill({
      //       type: 'strategy_map' as any,
      //       id: String(ctx.entityId || ''),
      //       name: ctx.entityName,
      //       fullPrompt: prompt,
      //       source: 'risk_mitigation' as any
      //     } as ChatPrefill);

      //     dispatch(resetAllChatsStreaming());
      //     dispatch(setIsNewChat(true));
      //     dispatch(setLastActiveChatId(null));
      //     dispatch(setShowChatbox(true));
      //     window.dispatchEvent(new CustomEvent('cadence:chat-prefill', {
      //       detail: {
      //         type: 'strategy_map',
      //         id: String(ctx.entityId || ''),
      //         name: ctx.entityName,
      //         fullPrompt: prompt,
      //         source: 'risk_mitigation'
      //       }
      //     }));
      //   }
      // },
      // {
      //     key: 'ai_prefill',
      //     waitFor: async () => waitForChatInput(),
      //     condition: () => hasAtRiskRoadmaps && !!context.entityId,
      //     message: "Here's a prefilled mitigation prompt. Adjust if needed.",
      //     placement: 'top'
      // }
    ]
   

  return (
    <Guider
      onboardingKey={OnboardingStepKeyEnum.StrategyMap}
      steps={steps}
    />
  );
}